<template>
  <div>
    <com-page>
      <com-card>
        <div>
          <el-tabs v-model="activeName">
            <el-tab-pane label="网点管理" name="0"></el-tab-pane>
            <el-tab-pane label="设备管理" name="1"></el-tab-pane>
            <el-tab-pane label="合伙人收益" name="2"></el-tab-pane>
            <el-tab-pane label="订单管理" name="3"></el-tab-pane>
            <el-tab-pane label="钱包管理" name="4"></el-tab-pane>
            <el-tab-pane label="充值订单管理" name="5"></el-tab-pane>
          </el-tabs>
        </div>
      </com-card>
      <com-card class="mt-15px">
        <div v-if="activeName === '0'">
          <partner-site :code="defaultParams.partnerCode" :level="partnerData.level"></partner-site>
        </div>
        <div v-if="activeName === '1'">
          <partner-equ :level="partnerData.level" :code="defaultParams.partnerCode"></partner-equ>
        </div>
        <div v-if="activeName === '2'">
          <partner-income
            :level="partnerData.level"
            :code="defaultParams.partnerCode"
          ></partner-income>
        </div>
        <div v-if="activeName === '3'">
          <partner-order
            :level="partnerData.level"
            :code="defaultParams.partnerCode"
          ></partner-order>
        </div>
        <div v-if="activeName === '4'">
          <partner-wallet
            :level="partnerData.level"
            :code="defaultParams.partnerCode"
          ></partner-wallet>
        </div>
        <div v-if="activeName === '5'">
          <partner-recharge
            :level="partnerData.level"
            :code="defaultParams.partnerCode"
          ></partner-recharge>
        </div>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import utils from 'my-tools-library'
import PartnerSite from './components/partner-site'
import PartnerEqu from './components/partner-equ'
import PartnerOrder from './components/partner-order'
import PartnerIncome from './components/partner-income'
import PartnerWallet from './components/partner-wallet'
import PartnerRecharge from './components/partner-recharge'

export default {
  components: {
    PartnerSite,
    PartnerEqu,
    PartnerOrder,
    PartnerIncome,
    PartnerWallet,
    PartnerRecharge
  },
  data() {
    return {
      activeName: '0',
      partnerCode: '',
      siteParams: {},
      equParams: {},
      defaultParams: {},
      partnerData: {}
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  },
  created() {
    const { row } = this.$route.params
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'partners-index' })
      return
    }
    this.partnerData = row
    this.defaultParams.partnerCode = row.code

    console.log('partnerData :>> ', this.partnerData)
  }
}
</script>

<style lang="scss" scoped></style>
